import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

// Export BOTH versions for convenience
export const useChatContext = () => useContext(ChatContext);
export const useChat = useChatContext;

export const ChatProvider = ({ children }) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openChat = (contact) => {
    setSelectedContact(contact);
    setIsOpen(true);
  };

  const closeChat = () => {
    setIsOpen(false);
    setSelectedContact(null);
  };

  return (
    <ChatContext.Provider
      value={{
        selectedContact,
        isOpen,
        openChat,
        closeChat,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
